module.exports = __webpack_public_path__ + "img/Bear05.c4877185.png";